import { useQuery } from '@apollo/client';
import { useEffect, useMemo } from 'react';
import getCountryFromTld from '../helpers/country-from-tld';
import GET_COUNTRY_BY_NAME from '../graphql/country/queries';

const useGetCountryFromUrl = (onCompleted = () => {}) => {
  const countryName = useMemo(() => getCountryFromTld(), []);

  const { data, loading, refetch, error } = useQuery(GET_COUNTRY_BY_NAME, {
    variables: { name: countryName },
    onCompleted,
    onError: () => setTimeout(refetch, 1500),
  });

  useEffect(() => {
    if (!error && !loading && !data?.getCountryByName) {
      refetch();
    }
  }, [loading, data]);

  return data?.getCountryByName;
};

export default useGetCountryFromUrl;
